import React from "react";
import styled from "styled-components";
export const Dashboard = (props) => {
    const { children, rows, columns } = props;
    return (React.createElement(Container, { rows: rows, columns: columns }, children));
};
const Container = styled.div `
  gap: 0.5rem;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${({ theme: { breakpoints } }) => breakpoints[3]}) {
    display: grid;
    align-items: stretch;
    grid-template-rows: ${({ rows }) => `repeat(${rows}, auto)`};
    grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
  }
`;
